import fetch from "@lib/fetch";

import { buildFetchRequestArgs } from "../formData";
import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdCanvasQa } from "./constants";
import type {
  PostwsGenerativeAiAppGroupIdCanvasQaPayload,
  PostwsGenerativeAiAppGroupIdCanvasQaProps,
} from "./types";
import { isCanvasQaResult } from "./validators";

export const postwsGenerativeAiAppGroupIdCanvasQa = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdCanvasQa,
  async (
    signal,
    {
      appGroupId,
      agentIds,
      canvasId,
      canvasDocument,
      scope,
      stepIds,
      jobToken,
      briefFile,
    }: PostwsGenerativeAiAppGroupIdCanvasQaProps
  ): Promise<{}> => {
    const payload: PostwsGenerativeAiAppGroupIdCanvasQaPayload = {
      job_token: jobToken,
      agent_ids: agentIds,
      canvas_id: canvasId,
      scope,
    };

    // The backend narrows to one step at a time today; send the first when a
    // per-step re-run asked for one. See PostwsGenerativeAiAppGroupIdCanvasQaProps.
    if (stepIds && stepIds.length > 0) {
      payload.step_id = stepIds[0];
    }

    if (canvasDocument) {
      // Multipart form-field flattening is lossy for the deeply nested canvas
      // document, so ship it as one JSON-encoded part when a brief is attached.
      payload.canvas_document = briefFile ? JSON.stringify(canvasDocument) : canvasDocument;
    }

    const { params, options, setContentType } = buildFetchRequestArgs(payload, briefFile);

    return await fetch(
      `/${appGroupId}/generative_ai/canvas_qa`,
      "POST",
      params,
      { signal, ...options },
      {
        setContentType,
        propagateFetchRequestError: false,
      }
    );
  },
  isCanvasQaResult
);
